import React, { useState } from "react";
import { OMSpinner } from "../../../atom/Spinner";
import { useTranslation } from "react-i18next";
import { ParticipantExam } from "../../../../types/components";
import { useInterval } from "../../../../utils/hooks/useInterval";
import { getFetcher } from "../../../../services/fetchers";
import { KeyedMutator } from "swr";
import { ParticipantExamQuestion } from "../../../../types/question";

interface CalculatingResultsProps {
  participantExamId: string;
  setResultExam: React.Dispatch<React.SetStateAction<ParticipantExam | null>>;
  mutateQuestions: KeyedMutator<ParticipantExamQuestion[]> | (() => void);
}

const REFETCH_INTERVAL = 3000;

export const CalculatingResults: React.FC<CalculatingResultsProps> = ({
  setResultExam,
  participantExamId,
  mutateQuestions,
}) => {
  const { t } = useTranslation();
  const [questionsLoading, setQuestionsLoading] = useState(false);

  useInterval(async () => {
    if (questionsLoading) {
      return;
    }

    const result: ParticipantExam = await getFetcher(
      `/common/participant-exam/${participantExamId}`,
    );

    if (result?.percentage == undefined) {
      return;
    }

    setQuestionsLoading(true);

    mutateQuestions()?.then(() => {
      setResultExam(result);
    });
  }, REFETCH_INTERVAL);

  return <OMSpinner text={t("Calculating results...")} />;
};
